module.exports = __webpack_public_path__ + "img/profile_img_01.64cd30fc.jpg";